import { SupabaseQueryParams } from '@app/shared/utils/interfaces';
import { createFeatureSelector, createSelector } from '@ngrx/store';

import { PRODUCTS_FEATURE_KEY, productsAdapter, ProductsState } from './products.reducer';

// Lookup the 'Products' feature state managed by NgRx
const getProductsState = createFeatureSelector<ProductsState>(PRODUCTS_FEATURE_KEY);

const { selectAll, selectEntities } = productsAdapter.getSelectors();

const getProductsLoading = createSelector(getProductsState, (state: ProductsState) => state.loading);

const getProductsLoaded = createSelector(getProductsState, (state: ProductsState) => state.loaded);

const getProductsError = createSelector(getProductsState, (state: ProductsState) => state.error);

const getAllProducts = createSelector(getProductsState, (state: ProductsState) => selectAll(state));

const getProductsEntities = createSelector(getProductsState, (state: ProductsState) => selectEntities(state));

const getSelectedId = createSelector(getProductsState, (state: ProductsState) => state.selectedId);

const getSelected = createSelector(getProductsEntities, getSelectedId, (entities, selectedId) =>
  selectedId ? entities[selectedId] : undefined,
);

const getPagination = createSelector(getProductsState, (state: ProductsState) => state.pagination);

const getQueryFilters = createSelector(getProductsState, (state: ProductsState) => state.queryFilters);

const getTotal = createSelector(getProductsState, (state: ProductsState) => state.total);

const getSizes = createSelector(getProductsState, (state: ProductsState) => state.sizes);

const getSupabaseQueryParams = createSelector(
  getProductsState,
  (state: ProductsState) =>
    ({
      ...state.supabaseQuery,
      ...state.pagination,
      ...state.queryFilters,
    }) as SupabaseQueryParams,
);

export const ProductsSelectors = {
  getProductsState,
  getProductsLoading,
  getProductsLoaded,
  getProductsError,
  getAllProducts,
  getProductsEntities,
  getSelectedId,
  getSelected,
  getQueryFilters,
  getPagination,
  getTotal,
  getSizes,
  getSupabaseQueryParams,
};
